module.exports = __webpack_public_path__ + "static/media/video.4e9f76d5.mp4";